<script>
import Layout from "../../layouts/main"
import PageHeader from "@/components/page-header"
import List from './list'

export default {
  components: {
    Layout,
    PageHeader,
    List,
  },
  data() {
    return {
      title: "Surplus",
      items: [
        {
          text: "VMCore"
        },
        {
          text: "Cashbox",
          // active: true
        },
        {
          text: "Surplus",
          active: true
        }
      ]
    }
  },
  methods: {
    onActiveChange(b) {
      this.$refs.list.setActive(!b)
    },
    onRefresh() {
      this.$refs.list.fetchData()
    },
    // onEdit(id) {
    //   this.$refs.form.initUpdate(id)
    // }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-12">
        <!-- <Form ref="form" @refresh="onRefresh" @active_change="onActiveChange" /> -->
        <List ref="list" @onEdit="onEdit" />
      </div>
    </div>
  </Layout>
</template>